<template>
  <img
    v-bind="$props"
    :src="src"
    :srcset="srcset"
  />
</template>

<script>
  export default {
    props: {
      src: {
        type: String,
        required: true,
      },
      width: {
        type: [String, Number],
        require: true,
      },
    },

    computed: {
      srcset() {
        const densities = ['2x', '3x']

        return densities
          .map(density => this.src.replace(/([A-Za-z0-9\-_]+)(\.(jpg|png|jpeg))/g, (match, fileName, fileExtension) => {
            const path = `${fileName}@${density}${fileExtension}`

            return `${path} ${density}`
          }))
          .join(',\n')
      },
    },
  }
</script>
